import Vue from 'vue'
import Vuex from 'vuex'
import ph from './ph'
import tn from './tn'
import ks from './ks'
import se from './se'
import ku from './ku'
import vo from './vo'
import structure from './structure'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeStep: 0,
    testCompleted: false,
    regions: {
      ...ph,
      ...tn,
      ...ks,
      ...se,
      ...ku,
      ...vo,
    },
    structure,
    user: {
      name: '',
      age: null,
      gender: '',
      email: '',
      school: '',
      year: '',
    },
  },
  getters: {
    activeQuestion: state => {
      return state.structure[state.activeStep] || null
    },
    userCompleted: ({ user, }) => {
      if (user.name && user.age && user.gender && user.email && user.age && user.school && user.year) {
        return true
      }
      return false
    },
    allSteps: state => {
      return Object.keys(state.structure).length
    },
  },
  mutations: {
    updateName(state, val) {
      state.user.name = val
    },
    updateEmail(state, val) {
      state.user.email = val
    },
    updateGender(state, val) {
      state.user.gender = val
    },
    updateAge(state, val) {
      state.user.age = val
    },
    updateSchool(state, val) {
      state.user.school = val
    },
    updateYear(state, val) {
      state.user.year = val
    },
    incrementStep(state) {
      state.activeStep++
    },
    decrementStep(state) {
      state.activeStep--
    },
    dislikeItem(state, id) {
      state.structure[state.activeStep].dislike = id
    },
    likeItem(state, id) {
      state.structure[state.activeStep].like = id
    },
    setTestCompleted(state) {
      state.testCompleted = true
    },
    setErrors(state, errors) {
      console.log(errors)
    },
  },
  actions: {
    updateUser({ commit, }, input) {
      if (input.name === 'name') return commit('updateName', input.value)
      if (input.name === 'email') return commit('updateEmail', input.value)
      if (input.name === 'gender') return commit('updateGender', input.value)
      if (input.name === 'age') return commit('updateAge', input.value)
      if (input.name === 'school') return commit('updateSchool', input.value)
      if (input.name === 'year') return commit('updateYear', input.value)
    },
    handlePrevClick({ commit, getters, state, }) {
      return commit('decrementStep')
    },
    handleNextClick({ commit, dispatch, getters, state, }) {
      if (Object.keys(state.structure).length === state.activeStep && getters.userCompleted) return dispatch('sendFormData')
      return commit('incrementStep')
    },
    sendFormData({ commit, getters, state, }) {
      let likes = []
      let dislikes = []

      let ksTotal = 0
      let kuTotal = 0
      let phTotal = 0
      let seTotal = 0
      let tnTotal = 0
      let voTotal = 0

      const calcTotal = (string, operation) => {
        if (string === 'ks' && operation === 'plus') return ksTotal++
        if (string === 'ks' && operation === 'minus') return ksTotal--

        if (string === 'ku' && operation === 'plus') return kuTotal++
        if (string === 'ku' && operation === 'minus') return kuTotal--

        if (string === 'ph' && operation === 'plus') return phTotal++
        if (string === 'ph' && operation === 'minus') return phTotal--

        if (string === 'se' && operation === 'plus') return seTotal++
        if (string === 'se' && operation === 'minus') return seTotal--

        if (string === 'tn' && operation === 'plus') return tnTotal++
        if (string === 'tn' && operation === 'minus') return tnTotal--

        if (string === 'vo' && operation === 'plus') return voTotal++
        if (string === 'vo' && operation === 'minus') return voTotal--
      }

      for (const key in state.structure) {
        if (state.structure.hasOwnProperty(key)) {
          const like = state.structure[key].like
          const dislike = state.structure[key].dislike
          likes.push(like)
          dislikes.push(dislike)

          calcTotal(like.substring(0, 2), 'plus')
          calcTotal(dislike.substring(0, 2), 'minus')
        }
      }

      const data = new FormData()
      data.append('name', state.user.name)
      data.append('age', state.user.age)
      data.append('email', state.user.email)
      data.append('school', state.user.school)
      data.append('gender', state.user.gender)
      data.append('year', state.user.year)
      data.append('likes', likes.join(', '))
      data.append('dislikes', dislikes.join(', '))
      data.append('ksTotal', ksTotal)
      data.append('kuTotal', kuTotal)
      data.append('phTotal', phTotal)
      data.append('seTotal', seTotal)
      data.append('tnTotal', tnTotal)
      data.append('voTotal', voTotal)

      axios({
        method: 'post',
        url: './form/form.php',
        data,
      })
        .then(res => {
          console.log(res)
          return commit('setTestCompleted')
        })
        .catch(err => {
          const errors = err.response.data
          console.log(err)
          console.log(err.response)
          return commit('setErrors', errors)
        })

      return console.log('Lets send dis shit!')
    },
  },
})
